import AccessoryUpsell from './AccessoryUpsell';

export default AccessoryUpsell;
